import {
  CHANGE_PAGE,
  CHANGE_PROJ,
  CHANGE_CARD,
  CHANGE_ITEM,
  DISPLAY_FOOTER,
} from "../actions/types";

let projectIDIni;
try {
  projectIDIni = localStorage.getItem("projectID");
} catch (e) {
  console.log("localstorage error", e);
}

let projectNameIni;
try {
  projectNameIni = localStorage.getItem("projectName");
} catch (e) {
  console.log("localstorage error", e);
}

let projectColorIni;
try {
  projectColorIni = localStorage.getItem("projectColor");
} catch (e) {
  console.log("localstorage error", e);
}

let itemIDIni;
try {
  itemIDIni = localStorage.getItem("itemID");
} catch (e) {
  console.log("localstorage error", e);
}

let itemNameIni;
try {
  itemNameIni = localStorage.getItem("itemName");
} catch (e) {
  console.log("localstorage error", e);
}

let itemColorIni;
try {
  itemColorIni = localStorage.getItem("itemColor");
} catch (e) {
  console.log("localstorage error", e);
}
// let itemTypeIni;
// try {
//   itemTypeIni = localStorage.getItem("itemType");
// } catch (e) {
//   console.log("localstorage error", e);
// }

const initialState = {
  pageTitle: "start",
  projectID: projectIDIni,
  projectName: projectNameIni,
  projectColor: projectColorIni,
  itemColor: itemColorIni,
  cardID: "",
  itemID: itemIDIni,
  cardName: "",
  itemName: itemNameIni,
  // itemType: itemTypeIni,
  footer: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    // case CHANGE_LAN:
    //   return {
    //     ...state,
    //     currLan: action.payload,
    //   };
    case CHANGE_PAGE:
      return {
        ...state,
        pageTitle: action.payload,
      };
    case CHANGE_PROJ:
      localStorage.setItem("projectID", action.payload._id);
      localStorage.setItem("projectName", action.payload.projectName);
      localStorage.setItem("projectColor", action.payload.projectColor);
      return {
        ...state,
        projectID: action.payload._id,
        projectName: action.payload.projectName,
        projectColor: action.payload.projectColor,
      };
    case CHANGE_CARD:
      return {
        ...state,
        cardID: action.payload._id,
        cardName: action.payload.name,
      };
    case CHANGE_ITEM:
      localStorage.setItem("itemID", action.payload._id);
      localStorage.setItem("itemName", action.payload.name);
      localStorage.setItem("itemColor", action.payload.itemColor);
      if (action.payload.hasOwnProperty("projectName")) {
        localStorage.setItem("projectID", action.payload.projectID);
        localStorage.setItem("projectName", action.payload.projectName);

        if (action.payload.hasOwnProperty("projectColor")) {
          localStorage.setItem("projectColor", action.payload.projectColor);

          return {
            ...state,
            itemID: action.payload._id,
            itemName: action.payload.name,
            projectID: action.payload.projectID,
            projectName: action.payload.projectName,
            itemColor: action.payload.itemColor,
            projectColor: action.payload.projectColor,
            // itemType: action.payload.itemType,
          };
        } else {
          // case of note chart
          return {
            ...state,
            itemID: action.payload._id,
            itemName: action.payload.name,
            projectID: action.payload.projectID,
            projectName: action.payload.projectName,
            // itemType: action.payload.itemType,
          };
        }
      } else {
        return {
          ...state,
          itemID: action.payload._id,
          itemName: action.payload.name,
          itemColor: action.payload.itemColor,
          // itemType: action.payload.itemType,
        };
      }
    case DISPLAY_FOOTER:
      return {
        ...state,
        footer: action.payload,
      };
    default:
      return state;
  }
}
